import { capitalCase } from "change-case";

import { loadLocale } from "@smart/itops-locale-dom";
import { Tab, Tabs } from "@smart/itops-sb-design-system-dom";
import { useLoadPendingSubmissions } from "@smart/manage-gql-client-dom";

import { CompletedSubmissions } from "./lists/completed-submissions";
import { PendingSubmissions } from "./lists/pending-submissions";
import { WebEnquiries } from "./lists/web-enquiries";

export const SubmissionLists = ({
  pendingSubmissions,
  activeTab,
  onTabChange,
  submissionId,
}: {
  pendingSubmissions: ReturnType<typeof useLoadPendingSubmissions>;
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  submissionId?: string;
}) => {
  const { terms } = loadLocale();

  const tabs: Tab[] = [
    {
      key: "web-enquiries",
      label: `Web ${capitalCase(terms.enquiry.plural)}`,
      icon: "regularGlobe",
      iconClassName:
        "bg-pink-150 hover:bg-pink-150 focus:bg-pink-150 active:bg-pink-150 active:border-bg-pink-150",
      activeIcon: "solidGlobe",
      component: <WebEnquiries openNoMatterSubmissionId={submissionId} />,
    },
    {
      key: "pending-forms",
      label: "Pending Forms",
      icon: "regularSpinner",
      iconClassName:
        "bg-blue-160 hover:bg-blue-160 focus:bg-blue-160 active:bg-blue-160 active:border-bg-blue-160",
      activeIcon: "solidSpinner",
      component: <PendingSubmissions pendingSubmissions={pendingSubmissions} />,
    },
    {
      key: "completed-forms",
      label: "Completed Forms",
      icon: "regularCheckCircle",
      iconClassName:
        "bg-green-200 hover:bg-green-200 focus:bg-green-200 active:bg-green-200 active:border-bg-green-200",
      activeIcon: "solidCircleCheck",
      component: <CompletedSubmissions />,
    },
  ];

  return (
    <div className="flex flex-1 m-auto pt-[0.4rem] pb-[4rem] px-[4rem] w-full bg-neutral-50 overflow-hidden min-h-[50rem]">
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
    </div>
  );
};
